module.exports = __webpack_public_path__ + "img/twoBlue.699cfe83.jpg";